// extracted by mini-css-extract-plugin
export default {"locationlogo":"Container1Search_locationlogo__W3Ilf","locationInput":"Container1Search_locationInput__rN0pW","searchInput":"Container1Search_searchInput__FttG8"};